import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import { ROLES } from "../utils/enums";
// import { DashboardData } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<CommonResponseType & { data: any }, void>({
      query: () => ({
        url: END_POINTS.dashboardData,
        method: "GET",
      }),
    }),
    getEmployeGraph: builder.query<
      CommonResponseType & { data: any },
      {
        type: number;
      }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.employeGraph}?type=${type}`,
        method: "GET",
      }),
    }),
    getFreelancerGraph: builder.query<
      CommonResponseType & { data: any },
      {
        type: number;
      }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.freelancerGraph}?type=${type}`,
        method: "GET",
      }),
    }),
    getTaskGraph: builder.query<
      CommonResponseType & { data: any },
      {
        type: number;
      }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.taskGraph}?type=${type}`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useLazyGetDashboardQuery,
  useLazyGetEmployeGraphQuery,
  useLazyGetFreelancerGraphQuery,
  useLazyGetTaskGraphQuery,
} = dashboardApi;
